import { createSlice } from '@reduxjs/toolkit';
import {
  fetchEnhancedSurveySubmissions,
  resetEnhancedSurveySubmission,
} from './actions';
import { EnhancedSurveySubmission } from './model';

export interface EnhancedSurveySubmissionsState {
  submissions: EnhancedSurveySubmission[];
  loadingSubmissions: boolean;
}

const initialState: EnhancedSurveySubmissionsState = {
  submissions: [],
  loadingSubmissions: false,
};

const enhancedSurveySubmissionsSlice = createSlice({
  name: 'enhancedSurveySubmissions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEnhancedSurveySubmissions.pending, (state) => {
        state.loadingSubmissions = true;
      })
      .addCase(fetchEnhancedSurveySubmissions.fulfilled, (state, action) => {
        state.submissions = action.payload;
        state.loadingSubmissions = false;
      })
      .addCase(fetchEnhancedSurveySubmissions.rejected, (state) => {
        state.submissions = [];
        state.loadingSubmissions = false;
      })
      .addCase(resetEnhancedSurveySubmission.pending, (state) => {
        state.loadingSubmissions = true;
      })
      .addCase(resetEnhancedSurveySubmission.fulfilled, (state, action) => {
        state.submissions = state.submissions.filter(
          (submission) => submission.sessionId !== action.meta.arg
        );
        state.loadingSubmissions = false;
      })
      .addCase(resetEnhancedSurveySubmission.rejected, (state) => {
        state.loadingSubmissions = false;
      });
  },
});

export default enhancedSurveySubmissionsSlice.reducer;
